<script>
import { RadioGroup } from 'element-ui';

export default {
  extends: RadioGroup,
};
</script>

<style lang="scss">
  .el-radio-group--vertical {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
  }

  .el-radio-group--media {
    margin-left: rem(-12px);
    margin-right: rem(-12px);

    .el-radio.radio-media {
      max-width: rem(160px);
      flex-basis: rem(160px);
      padding-right: rem(15px);
      margin-bottom: rem(15px);
      padding-left: rem(15px);

      & + .el-radio {
        margin-left: 0;
      }
    }
  }

  .el-radio-group {
    &.is-disabled {
      cursor: not-allowed;
    }
  }

  .el-radio-group--tiles {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 10px 4px;
    width: 100%;

    @media only screen and (max-width: $--lg - 1px) {
      grid-template-columns: repeat(5, 1fr);
    }

    @media only screen and (max-width: $--md - 1px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media only screen and (max-width: $--sm - 1px) {
      grid-template-columns: repeat(2, 1fr);
      row-gap: 4px;
    }

    @media only screen and (max-width: $--xs - 1px) {
      grid-template-columns: 1fr;
    }
  }
</style>
